import { useContext } from "react";
import { ResourceContext } from "../../Service/Context/ResourceContext";
import { LoadingAnimation } from "../../Service/ResourceAdapter";
import { getDocumentTranslator } from "../Document/documentLanguage";
import { useLingui } from "@lingui/react";

const BankAccountAndTaxNumbers = ({ language }) => {
  const { profile, bankAccount, loading } = useContext(ResourceContext);
  const { i18n } = useLingui();
  const t = getDocumentTranslator(i18n, language);

  if (loading) {
    return <LoadingAnimation />;
  }
  const isPropDefined = (prop) => prop && prop !== "";

  const styles = {
    listStyle: {
      display: "block",
      listStyleType: "none",
      marginBottom: 5,
      paddingLeft: 0,
      flexWrap: "wrap",
    },
    itemStyle: {
      marginRight: "unset",
      fontSize: 12,
    },
  };
  const {
    taxNumber,
    vatId
  } = profile;

  const {
    iban
  } = bankAccount ?? {};

  return (
    <ul style={styles.listStyle}>
      {isPropDefined(iban) ? (
          <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
            IBAN: {iban}
          </li>
      ) : (
          <br />
      )}
      {isPropDefined(vatId) ? (
          <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
            {t("vatIdLabel")}: {vatId}
          </li>
      ) : (
          <br />
      )}
      {isPropDefined(taxNumber) ? (
          <li style={{ ...styles.itemStyle, listStyleType: "none" }}>
            {t("taxNumberLabel")}: {taxNumber}
          </li>
      ) : (
          <br />
      )}
    </ul>
  );
};

export default BankAccountAndTaxNumbers;
